
import React from 'react';
import { Link } from 'react-router-dom';
import { SheetClose } from '@/components/ui/sheet';

const MobileResourcesMenu = () => {
  return (
    <div className="space-y-2 ml-4">
      <SheetClose asChild>
        <Link
          to="/polls"
          className="block text-base font-medium text-foreground hover:text-nation-blue transition-colors"
        >
          Public Polls
        </Link>
      </SheetClose>
      <SheetClose asChild>
        <Link
          to="/insights"
          className="block text-base font-medium text-foreground hover:text-nation-blue transition-colors"
        >
          Insights
        </Link>
      </SheetClose>
      <SheetClose asChild>
        <Link
          to="/civic-education"
          className="block text-base font-medium text-foreground hover:text-nation-blue transition-colors"
        >
          Civic Education
        </Link>
      </SheetClose>
      <SheetClose asChild>
        <Link
          to="/countries"
          className="block text-base font-medium text-foreground hover:text-nation-blue transition-colors"
        >
          Countries
        </Link>
      </SheetClose>
    </div>
  );
};

export default MobileResourcesMenu;
